module.exports = __webpack_public_path__ + "img/w3_trash_light.12a6f619.png";